import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hgtablesps",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  presets: [
    {
      label: "greis:widgets.table_sps.title",
      description: "greis:widgets.table_sps.description",
      imageLink: require("./preset.png"),
      tags: ["H&G"],
      layout: [6, 24],
      widget: {
        config: {
          _history: {
            historyType: "relative",
            value: 3,
            unit: "month",
          },
        },
      },
    },
  ],
});
